import { event } from 'react-ga'

export const gaLinkEvent = (action, label) => {
  event({
    category: 'Links',
    action,
    label
  })
}
